import { styled } from '@mui/material';
import { Button, Typography } from '@totalsoft/rocket-ui';

export const BoldButton = styled(Button)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold
}));

export const CorrelationIdLink = styled(Typography, { shouldForwardProp: prop => !['active'].includes(prop) })(({ theme, active }) => ({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  ...(active && {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeightBold
  }),
  ...(!active && {
    color: theme.palette.text.primary,
    cursor: 'initial'
  })
}));
